import { getAPIUrl } from '../helpers/App';

export const APIgetPaymentProducts = sessionId => (
  window.axios.get(getAPIUrl('/payments/products'), { params: { session_id: sessionId } })
    .then(response => (response))
);

export const APIpaymentCheckout = priceId => (
  window.axios.post(getAPIUrl('/payments/checkout'), { price_id: priceId })
    .then(response => (response))
);

export const APIcustomerPortal = (params) => (
  window.axios.post(getAPIUrl('/payments/portal'), params)
    .then(response => (response))
);

export const APIpaymentChangePlan = (priceId) => (
  window.axios.patch(getAPIUrl('/payments/price'), { price_id: priceId })
    .then(response => (response))
);

export const APIpaymentCancel = () => (
  window.axios.delete(getAPIUrl('/payments/price'))
    .then(response => (response))
);

export const APIstartTrial = () => (
  window.axios.post(getAPIUrl('/payments/trial'))
    .then(response => (response))
);
